<template>
  <transition :name="transitionName">
    <div
      v-if="show"
      class="g-modal overlay"
      :class="[`type--${type}`, overflowScroll ? `overflow--${overflowScroll}` : null]"
      @click.self="closeFromMask"
    >
      <section
        class="content"
        :class="[`type--${type}`, type === 'drawer' ? drawerDirection : null]"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="content-header" id="modalTitle" v-if="hasHeaderSlot">
          <slot name="header" v-bind="{ close }"></slot>
        </header>
        <div class="content-body" id="modalDescription">
          <slot v-bind="{ close }"></slot>
        </div>
        <footer class="content-footer" v-if="hasFooterSlot">
          <slot v-bind="{ close }" name="footer"></slot>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
// QUESTION: Should drawer and modal be part of the same component? Should I have something more abstract. like and overlay component and a card that can go in it? then I style from there? They do share open hide logic but transitions and stuff are sort of brand specific.
// TODO figure out a system for creating new transitions
export default {
  name: 'GModal',
  model: {
    prop: 'show',
    event: 'update:show',
  },
  props: {
    /** disable closing by clicking on overlay outside of modal */
    disableClosingOnMask: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    disableScrolling: {
      type: Boolean,
      default: false,
    },
    drawerDirection: {
      type: String,
      default: 'from-left',
    },
    transition: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'modal',
      validator(value) {
        return ['modal', 'drawer'].indexOf(value) !== -1;
      },
    },
    overflowScroll: {
      type: [String, Boolean],
      default: 'content',
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$scopedSlots.header;
    },
    hasFooterSlot() {
      return !!this.$scopedSlots.footer;
    },
    transitionName() {
      if (this.transition) return this.transition;
      if (this.$mq === 'sm') return 'modal-fade';
      if (this.type === 'modal') return 'modal-fade';
      if (this.type === 'drawer') return `modal-slide-${this.drawerDirection}`;
      return 'modal-fade';
    },
  },
  methods: {
    closeFromMask() {
      if (this.disableClosingOnMask) return;
      this.close();
    },
    close() {
      this.$emit('closed', false);
      this.$emit('update:show', false);
    },
    disableScroll() {
      document.body.style.overflow = 'hidden';
    },
    enableScroll() {
      document.body.style.overflow = 'auto';
    },
    scrollCheck(disable) {
      if (disable) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    },
  },
  watch: {
    disableScrolling(disable) {
      if (!disable) {
        this.scrollCheck(false);
      }
    },
    show(isOpen) {
      if (this.disableScrolling) {
        this.scrollCheck(isOpen);
      }
    },
  },
};
</script>

<style lang="scss">
.g-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;

  &.overlay {
    background-color: rgba(0, 0, 0, 0.75);
  }

  &.overflow {
    &--overlay {
      overflow: auto;
    }
    &--content {
      > .content {
        max-height: 100vh;
        overflow: auto;
      }
    }
  }

  &.type--drawer {
    overflow: hidden;
  }

  > .content {
    box-sizing: border-box;
    background-color: var(--g-modal-background-color);

    &.type--modal {
      margin: auto;
    }

    &.type--drawer {
      width: 100%;
      max-width: 420px;
      height: 100%;
      overflow: auto;

      &.from-left {
        margin: 0 auto 0 0;
      }
      &.from-right {
        margin: 0 0 0 auto;
      }
    }
    &-header {
      display: flex;
    }
    &-body {
      position: relative;
    }
    &-footer {
      display: flex;
      margin-top: auto;
    }
  }

  // Default Transitions
  &.modal-fade-enter,
  &.modal-fade-leave-active {
    opacity: 0;
  }
  &.modal-fade-enter-active,
  &.modal-fade-leave-active {
    transition: opacity 0.5s ease;
  }

  &.modal-slide-from-left-enter,
  &.modal-slide-from-left-leave-to {
    opacity: 0;

    .content {
      transform: translateX(-100%);
    }
  }
  &.modal-slide-from-right-enter,
  &.modal-slide-from-right-leave-to {
    opacity: 0;

    .content {
      transform: translateX(100%);
    }
  }
  &.modal-slide-from-left-enter-to,
  &.modal-slide-from-left-leave,
  &.modal-slide-from-right-enter-to,
  &.modal-slide-from-right-leave {
    opacity: 1;
    .content {
      transform: translateX(0);
    }
  }
  &.modal-slide-from-left-enter-active,
  &.modal-slide-from-left-leave-active,
  &.modal-slide-from-right-enter-active,
  &.modal-slide-from-right-leave-active {
    transition: opacity 0.5s ease;

    .content {
      transition: transform 0.5s ease;
    }
  }
}
</style>
